import { getDatetimeText, removeEmpty } from '@back-office/ui';
import { DateRange } from '@material-ui/pickers';
import { endOfDay } from 'date-fns';
import { useLocalStore } from 'mobx-react';
import qs from 'query-string';
import { MouseEvent } from 'react';
import { Store } from '.';
import useInject from '../../../hooks/useInject';

const useViewModel = (handleOnClose: () => void): { state: Store } => {
  const { auth, getRecurringTransactionReport } = useInject((root) => root);

  const state = useLocalStore<Store>(() => ({
    date: [null, null],
    openCalendar: false,
    get query(): string {
      return qs.stringify(
        removeEmpty({
          merchantID: auth.currentUser.merchantID,
          start_date_from: this.date[0]
            ? getDatetimeText(this.date[0], 'json')
            : null,
          start_date_to: this.date[1]
            ? getDatetimeText(endOfDay(this.date[1]), 'json')
            : null,
        })
      );
    },
    handleOnChangeDatePicker(date: DateRange<Date>) {
      this.date = date;
    },
    handleOnClear(event: MouseEvent<HTMLOrSVGElement>) {
      event.stopPropagation();
      this.openCalendar = false;
      this.date = [null, null];
      handleOnClose();
    },
    handleOnClickDatePicker() {
      this.date = [null, null];
      this.openCalendar = true;
    },
    handleOnCloseDatePicker() {
      if (this.date[0] && this.date[1]) {
        this.openCalendar = false;
      }
    },
    handleClose(event: MouseEvent<HTMLOrSVGElement>, reason: string) {
      if (reason === 'backdropClick') {
        this.openCalendar = false;
        state.handleOnClear(event);
      }
    },
    async handleOnExport() {
      if (this.date[0] && this.date[1]) {
        await getRecurringTransactionReport(this.query).finally(() =>
          handleOnClose()
        );
      }
      this.date = [null, null];
    },
  }));

  return {
    state,
  };
};

export default useViewModel;
